var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInvitationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.19157V11.1916C18.3333 12.4416 17.9167 13.4832 17.1833 14.2166C16.4583 14.9416 15.4167 15.3582 14.1667 15.3582V17.1332C14.1667 17.7999 13.425 18.1999 12.875 17.8333L9.16666 15.3582H7.39999C7.46666 15.1082 7.49999 14.8499 7.49999 14.5832C7.49999 13.7332 7.17499 12.9499 6.64166 12.3583C6.04166 11.6749 5.14999 11.2499 4.16666 11.2499C3.23332 11.2499 2.38333 11.6333 1.77499 12.2583C1.69999 11.9249 1.66666 11.5666 1.66666 11.1916V6.19157C1.66666 3.69157 3.33332 2.0249 5.83332 2.0249H14.1667C16.6667 2.0249 18.3333 3.69157 18.3333 6.19157Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 14.5833C7.50001 14.85 7.46668 15.1083 7.40001 15.3583C7.32501 15.6917 7.19169 16.0167 7.01669 16.3C6.44169 17.2667 5.38334 17.9167 4.16668 17.9167C3.30834 17.9167 2.53334 17.5916 1.95001 17.0583C1.70001 16.8416 1.48333 16.5833 1.31667 16.3C1.00833 15.8 0.833344 15.2083 0.833344 14.5833C0.833344 13.6833 1.19168 12.8584 1.77501 12.2584C2.38335 11.6334 3.23334 11.25 4.16668 11.25C5.15001 11.25 6.04168 11.675 6.64168 12.3583C7.17501 12.95 7.50001 13.7333 7.50001 14.5833Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40812 14.5664H2.9248",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16666 13.3496V15.8413",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08334 8.75H12.9167",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvitationActive);
export default __webpack_public_path__ + "static/media/IconInvitationActive.5e7d85329c6e7a6a90f952b7b57715dc.svg";
export { ForwardRef as ReactComponent };